export default {
	"IF Sokak'tan 4 iPhone 17 ve 16 AirPods hediye": '4 iPhone 17s and 16 AirPods to win from IF Sokak',
	'Şubelere göre çekiliş hakların!': 'Your raffle entries by branch!',
	'Kampanya Detayları': 'Campaign Details',
	'Sipariş Numarası': 'Order Number',
	'Self servis siparişlerde lütfen sana verilecek sipariş numarasını takip et.':
		'For self-service orders, please keep track of the order number you are given.',
	'Siparişin tamamlanıyor, sipariş numaranı birazdan burada göstereceğiz.':
		'Your order is being completed; we will show your order number here shortly.',
	'Bu siparişinden <0>{{count}}</0> çekiliş hakkı kazandın!': 'You earned <0>{{count}}</0> raffle entries from this order!',
	'Hakların en geç 30 dakika içinde hesabına otomatik olarak tanımlanır.':
		'Your entries will be added to your account automatically within 30 minutes at the latest.',
	'Kampanyaya katıl, bu siparişinden <0>{{count}}</0> çekiliş hakkı kazan; iPhone 17 ve AirPods kazanma şansını yakala!':
		'Join the campaign, earn <0>{{count}}</0> raffle entries from this order and grab your chance to win an iPhone 17 or AirPods!',
	'Çekilişe katılmak için giriş yap': 'Log in to join the raffle',
	'Giriş Yap / Üye Ol': 'Log In / Sign Up',
	'Giriş yap, kampanyaya katıl; her siparişin iPhone 17 ve AirPods kazanma şansına dönüşsün.':
		'Log in and join the campaign to turn every order into a chance to win an iPhone 17 or AirPods.',
	'Kampanya Milli Piyango İdaresi Genel Müdürlüğü’nün 13.10.2026 tarih ve E-40453693-255.01.02-98673 sayılı izni ile düzenlenmektedir.':
		'This campaign is organised with the permission of the General Directorate of National Lottery Administration (Milli Piyango İdaresi Genel Müdürlüğü), dated 13.10.2026 and numbered E-40453693-255.01.02-98673.',
	'Bu siparişin ile çekiliş hakkı kazanabilirsin.': 'You can earn raffle entries with this order.',
	'Kampanya katılım koşulları': 'Campaign participation terms',
	'Bu kampanya Milli Piyango İdaresi Genel Müdürlüğü’nün 13.10.2026 tarih ve E-40453693-255.01.02-98673 sayılı izni ile düzenlenmekte olup, 15.10.2026 21.00 – 11.11.2026 23.59 tarihleri arasında Ankara IF Sokak Tunus Caddesi, Tepe Prime, Söğütözü ve Eryaman şubeleri ile IF Sokak mobil uygulamasında geçerlidir. Yalnızca uygulamaya üye bireysel müşterilere yöneliktir. Her gün 21.00\'den kapanışa kadar yemek, tatlı ve alkolsüz içeceklerden (alkollü ve seçenekli içecek içeren menüler ile masama getir ve paket servis ücretleri dahil değildir) tek seferde 500 TL ve katları tutarında (her 500 TL için 1 çekiliş hakkı) alışveriş yaparak; "If Sokak" mobil uygulamasını ücretsiz indirip ad, soyad, telefon no. ve e-mail bilgileriyle üye olduktan sonra ana ekranda çıkan ilgili kampanyaya katıl butonuna tıklayarak açılan ekranda üyelik bilgilerine ek olarak adres ve doğum tarihi bilgilerini doldurup onaylayarak kampanya katılımı sonrası alışveriş fişindeki benzersiz güvenlik kodlu QR kodunu uygulama içerisindeki "QR ile Çekiliş Hakkı Ekle" alanına okuttuklarında çekiliş hakkı (Uygulama üzerinden verilen siparişlerde çekiliş hakları hesaba otomatik olarak tanımlanacaktır.) verilecektir. Çekilişler 17.11.2026 saat 10.30\'da Kavaklıdere Tunus Cad. No:46 Çankaya/Ankara adresinde, noter huzurunda ve her şube için ayrı yapılacaktır. İkramiyeler: Tunus Caddesi Şubesi için 1 adet Apple iPhone 17 256 GB, 4 adet Apple AirPods 4, Tepe Prime Şubesi için 1 adet Apple iPhone 17 256 GB, 4 adet Apple AirPods 4, Söğütözü Şubesi için 1 adet Apple iPhone 17 256 GB, 4 adet Apple AirPods 4, Eryaman Şubesi için 1 adet Apple iPhone 17 256 GB, 4 adet Apple AirPods 4 şeklindedir. 18 yaş altı, şube çalışanları, tüzel kişiler ve toplu alım yapanlar katılamaz. ÖTV ve KDV hariç yasal yükümlülükler talihlilere aittir. Tüm koşullar IF Sokak uygulamasındadır.':
		'This campaign is organised with the permission of the General Directorate of National Lottery Administration (Milli Piyango İdaresi Genel Müdürlüğü), dated 13.10.2026 and numbered E-40453693-255.01.02-98673, and is valid between 15.10.2026 21:00 and 11.11.2026 23:59 at the IF Sokak Tunus Caddesi, Tepe Prime, Söğütözü and Eryaman branches in Ankara and in the IF Sokak mobile app. It is open only to individual customers who are members of the app. Raffle entries are given for single purchases of 500 TL or multiples thereof (1 raffle entry per 500 TL) of food, desserts and non-alcoholic drinks made every day from 21:00 until closing (menus containing alcoholic or optional drinks, as well as bring-to-table and delivery fees, are excluded), once customers download the "If Sokak" mobile app for free, sign up with their name, surname, phone number and e-mail address, tap the join campaign button on the home screen, fill in and confirm their address and date of birth in addition to their membership details on the screen that opens, and, after joining the campaign, scan the QR code with a unique security code on their receipt in the "Add Raffle Entry with QR" section of the app. (For orders placed through the app, raffle entries are added to the account automatically.) The draws will be held on 17.11.2026 at 10:30 at Kavaklıdere Tunus Cad. No:46 Çankaya/Ankara, in the presence of a notary public, separately for each branch. Prizes: for the Tunus Caddesi Branch, 1 Apple iPhone 17 256 GB and 4 Apple AirPods 4; for the Tepe Prime Branch, 1 Apple iPhone 17 256 GB and 4 Apple AirPods 4; for the Söğütözü Branch, 1 Apple iPhone 17 256 GB and 4 Apple AirPods 4; for the Eryaman Branch, 1 Apple iPhone 17 256 GB and 4 Apple AirPods 4. Persons under 18, branch employees, legal entities and bulk purchasers cannot participate. Legal obligations other than SCT (ÖTV) and VAT (KDV) belong to the winners. All terms and conditions are available in the IF Sokak app.',
	'Sipariş Eşleştir': 'Redeem Order',
	'Çekiliş Haklarım': 'My Raffle Entries',
	'Çekilişe katılabilmen için eksik bilgilerini tamamlaman gerekiyor.':
		'You need to complete your missing information to join the raffle.',
	'Bilgilerimi Tamamla': 'Complete My Information',
	'Doğum Tarihin': 'Your Date of Birth',
	'GG/AA/YYYY': 'DD/MM/YYYY',
	'Doğum tarihini girmelisin.': 'You must enter your date of birth.',
	'Adresin': 'Your Address',
	'Adresini girmelisin.': 'You must enter your address.',
	"If Sokak Çekiliş Kampanyası Katılım Koşulları'nı": 'the If Sokak Raffle Campaign Participation Terms',
	'<0>{{title}}</0> okudum, anladım ve kabul ediyorum.': 'I have read, understood and accept <0>{{title}}</0>.',
	"Açık Rıza Metni'ni": 'the Explicit Consent Text',
	'Kampanya ve çekiliş süreçleri kapsamında kişisel verilerimin işlenmesine ve ilgili kurumlara aktarılmasına ilişkin <0>{{title}}</0> onaylıyorum.':
		'I approve <0>{{title}}</0> regarding the processing of my personal data and its transfer to the relevant institutions within the scope of the campaign and raffle processes.',
	'Açık Rıza Metni\'ni onaylamalısın.': 'You must approve the Explicit Consent Text.',
	'Çekiliş katılım koşullarını onaylamalısın.': 'You must accept the raffle participation terms.',
	'Kampanyaya Katıl': 'Join the Campaign',
	'Çekiliş Detayları': 'Raffle Details',
	'Sipariş fişindeki QR kodu okutarak çekiliş haklarını hesabına ekleyebilirsin.':
		'Scan the QR code on your receipt to add raffle entries to your account.',
	'Henüz çekiliş hakkı kazandıran bir siparişin bulunmuyor.':
		'You don’t have any orders that earned raffle entries yet.',
	hak: 'entry',
	'Çekiliş Kodu:': 'Raffle Code:',
	'Siparişin çekilişe tanımlanıyor...': 'Adding your order to the raffle...',
	'Çekiliş şu anda aktif değil.': 'The raffle is not active right now.',
	'Çekiliş hakların kontrol ediliyor...': 'Checking your raffle entries...',
	'Bu siparişten {{total}} çekiliş hakkı kazandın.':
		'You earned {{total}} raffle entries from this order.',
	'Bu siparişten daha önce {{total}} çekiliş hakkı kazanmıştın.':
		'You had already earned {{total}} raffle entries from this order.',
	'Sipariş bilgisine ulaşılamadı, lütfen QR kodu tekrar okut.':
		'Order information could not be found, please scan the QR code again.',
	'Siparişin çekiliş haklarına eklendi.': 'Your order has been added to your raffle entries.',
	'Siparişin çekilişe tanımlanırken bir hata ile karşılaşıldı, lütfen tekrar dene.':
		'An error occurred while adding your order to the raffle, please try again.',
	'Çekiliş bilgilerin getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar dene.':
		'An error occurred while fetching your raffle information, please try again later.',
	// Samimi (sen) hitap: core'daki resmi metinlerin ifsokak karşılıkları.
	'* Kampanyalarla ilgili iletişim tercihlerini kapattığında siparişlerin ve üyelik ayarlarınla ilgili tüm bildirimleri almaya devam edebilirsin.':
		'* When you turn off campaign-related communication preferences, you will continue to receive all notifications related to your orders and membership settings.',
	'6 haneli SMS kodunu gir.':
		'Enter the 6-digit SMS code.',
	'Adın':
		'Your First Name',
	'Adın Soyadın':
		'Your Full Name',
	'Adını girmelisin.':
		'You must enter your first name.',
	'Arama geçmişin boş, arama kutusuna aramak istediğin ürünü yazarak hemen aramaya başlayabilirsin.':
		'Your search history is empty. You can start searching by typing the product you are looking for in the search box.',
	'Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.':
		'An error occurred while loading search results, please try again.',
	'Bilgilendirme: Sipariş verdiğin her şube bağımsız olarak hizmet vermektedir. Bu nedenle kart bilgilerini her şube için ayrı kaydetmen gerekir.':
		'Please note: Each branch you order from operates independently. Therefore, you need to save your card details separately for each branch.',
	'Bu kartı kayıtlı kartlarından çıkarmak istediğine emin misin?':
		'Are you sure you want to remove this card from your saved cards?',
	'Bu ürünü şu an sepetine ekleyemezsin.':
		'You cannot add this item to your basket at the moment.',
	'CVV girmelisin.':
		'You must enter the CVV.',
	'E-Posta Adresin':
		'Your Email Address',
	'E-posta adresini girmelisin.':
		'You must enter your email address.',
	'Geçerli bir e-posta adresi girmelisin.':
		'You must enter a valid email address.',
	'Geçerli bir isim girmelisin.':
		'You must enter a valid name.',
	'Geçerli bir telefon numarası girmelisin.':
		'You must enter a valid phone number.',
	'Hatalı bir QR okuttun.':
		'You scanned an invalid QR code.',
	'Hesabın misafir kullanıcı olarak tanımlı olduğu için bazı bilgilerin eksik. Uygulamayı kullanmaya başlamak için lütfen aşağıdaki bilgileri doldur.':
		'Your account is registered as a guest user, so some of your information is incomplete. Please fill in the details below to start using the app.',
	'Hesabın var mı? Hemen':
		'Already have an account? Right away',
	'Hesabına kayıtlı bir ödeme yöntemi bulunmuyor. Sipariş verirken kartını kaydedebilirsin.':
		'You have no saved payment method on your account. You can save your card while placing an order.',
	'Hesabını Silme':
		'Deleting Your Account',
	'Hesabını iptal etmek istediğine emin misin?':
		'Are you sure you want to cancel your account?',
	'Hesabını silmek istediğinde talebin 24 saat içerisinde sonuçlanacak. 6 ay boyunca bilgilerin sistemimizde saklı kalacaktır.':
		'When you request to delete your account, the process will be completed within 24 hours. Your information will remain in our system for 6 months.',
	'Hesap silme talebini <strong>{{date}}</strong> tarihi itibariyle aldık. Bu tarihten itibaren en geç 15 gün içinde hesap bilgilerin tamamen silinecek.':
		'We received your account deletion request as of <strong>{{date}}</strong>. Your account information will be completely deleted within 15 days from this date at the latest.',
	'IF Sokak uygulamamızı kullanarak şubelerimizde kolayca sipariş verebilirsin.':
		'You can easily place orders at our branches using the IF Sokak app.',
	'KVKK metnini onaylamalısın.':
		'You must accept the KVKK text.',
	'Kart numaranı girmelisin.':
		'You must enter your card number.',
	'Kart üzerindeki isim alanını girmelisin.':
		'You must enter the name on the card.',
	'Kartın başarıyla silindi.':
		'Your card was deleted successfully.',
	'Kartın silinirken bir hata ile karşılaşıldı, lütfen tekrar dene.':
		'An error occurred while deleting your card, please try again.',
	'Kategorileri görmek için "<Link href="placeOrder" className="hyperlink">Sipariş Ver</Link>" butonuna tıklayarak QR kodunu okut.':
		'To see the categories, click on the "<Link href="placeOrder" className="hyperlink">Place Order</Link>" button to read the QR code on your table.',
	'Kayıtlı Kartların':
		'Your Saved Cards',
	'Kayıtlı Kartın Bulunmuyor.':
		'You Have No Saved Cards.',
	'Kayıtlı e-posta adresine gönderilen şifreyi gir.':
		'Please enter the password sent to your registered email address.',
	'Kullanıcı bilgilerin getirilirken bir hata ile karşılaşıldı. Lütfen sayfayı yenileyerek tekrar dene.':
		'An error occurred while fetching your user information. Please refresh the page and try again.',
	'Masa Numaranı Gir':
		'Enter Your Table Number',
	'Masa numaranı girmelisin.':
		'You must enter your table number.',
	'Mağazamızdaki kiosk ve kasalardan sipariş verebilirsin.':
		'You can place orders at our in-store kiosks and cashiers.',
	'Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.':
		'An error occurred while loading the menu, please try again.',
	'Mesafeli satış sözleşmesini kabul etmelisin.':
		'You must accept the distance sales agreement.',
	'Mesajın':
		'Your Message',
	'Mobil uygulamamızı indirerek hızlı ve sıra beklemeden sipariş verebilir, masaya getir özelliği ile yerinden kalkmadan siparişine ulaşabilirsin.':
		'Download our mobile app to order quickly without waiting in line, and have your order delivered to your table without leaving your seat.',
	'SKT seçmelisin.':
		'You must select the expiry date.',
	'SMS kodunu gir.':
		'Enter the SMS code.',
	'Sepetin getirilirken bir hata ile karşılaşıldı.':
		'An error occurred while loading your basket.',
	'Sepetin getiriliyor...':
		'Loading your basket...',
	'Sepetinde ürün bulunmuyor.':
		'Your basket is empty.',
	'Sepetine ürün eklemek için oturduğun masanın numarasını girmelisin.':
		'You must enter your table number to add items to your basket.',
	'Servis yöntemi seçmelisin.':
		'You must select a service method.',
	'Sipariş bilgisi getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar dene.':
		'An error occurred while loading order information, please try again later.',
	'Siparişin bulunmuyor.':
		'You have no orders.',
	'Siparişler getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar dene.':
		'An error occurred while loading orders, please try again later.',
	'Site için bir güncelleme var. Lütfen sayfayı yenile.':
		'There is an update available for the site. Please refresh the page.',
	'Soyadın':
		'Your Surname',
	'Soyadını girmelisin.':
		'You must enter your surname.',
	'Tam adını girmelisin.':
		'You must enter your full name.',
	'Telefon Numaran':
		'Your Phone Number',
	'Telefon numaranı girmelisin.':
		'You must enter your phone number.',
	'Uygulama üzerinden giriş yapmış olduğun için':
		'Since you signed in through the app',
	'Veri silme talebini aşağıdaki formu doldurarak bize iletebilirsin.':
		'You can submit your data deletion request by filling out the form below.',
	'Yeni Kart Ekle':
		'Add a New Card',
	'iyzico kart saklama, ödeme kartlarını saklayarak, daha sonraki işlemlerinde kart bilgilerini tekrar vermeden kolay ve hızlı ödeme yapabilmeni sağlayan güvenli bir servistir.':
		'iyzico card saving is a secure service that allows you to save payment cards and make easy and fast payments in your future transactions without having to enter your card information again.',
	'{{phone}} numaralı telefonuna gönderilen şifreyi gir.':
		'Please enter the password sent to <0>{{phone}}</0>.',
	'{{phone}} numaralı telefonuna ve kayıtlı e-posta adresine gönderilen şifreyi gir.':
		'Please enter the password sent to <0>{{phone}}</0> and your registered email address.',
	'Çıkış yapmak istediğine emin misin?':
		'Are you sure you want to sign out?',
	'Ödeme yapacağın kartı seçmelisin.':
		'You must select the card you want to pay with.',
	'Ödeme yapmak istediğin kartı seçmelisin.':
		'You must select the card you want to pay with.',
	'Ödemen bu kart ile yapılacak.':
		'Your payment will be made with this card.',
	'Ürün getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.':
		'An error occurred while loading the product, please try again.',
	'Ürün için sipariş notların.':
		'Order notes for this product.',
	'Üyelik sözleşmesini onaylamalısın.':
		'You must accept the membership agreement.',
	'Üyeliğin yoksa lütfen aşağıdan üye ol.':
		'If you do not have an account, please register below.',
	'Giriş Yapmalısın':
		'You Need to Log In',
	'Senin için Seçtiklerimiz':
		'Picked for You',
	'kayıtlı kartın bulunuyor.':
		'saved card(s) found.',
	'sayfasının alt kısmında bulunan "Hesabımı Sil" butonu üzerinden hesabını silme talebini bize iletebilirsin.':
		'page, you can send us your account deletion request using the "Delete My Account" button at the bottom.',
	'Ödeme adımına geçmek için giriş yapman gerekiyor.':
		'You need to log in to proceed to payment.',
	'Ürünü sepetinden çıkarmak istediğine emin misin?':
		'Are you sure you want to remove this product from your basket?',
};
